import { SortableWidget, Page } from './PortalPlugin';

export interface State {
  dashboardWidgets: SortableWidget[];
  pages: Page[];
}

export const state: State = {
  dashboardWidgets: [],
  pages: [],
};



// WEBPACK FOOTER //
// ./src/framework/state.tsx